import * as flex from '@liberty-rider/flexpolyline';
import { HERE_MAPS_API_KEY, ROUTER_API } from '@/config/here';
import {
  type GetVehicleRouteResponseVM,
  type VehicleRoutePoint,
  type RouteWeekDay,
} from '@/app/services/solution/types/get-vehicle-route';

interface Location {
  latitude: number;
  longitude: number;
  name: string;
}

const locations: Location[] = [
  { latitude: 59.332_57, longitude: 18.066_83, name: 'Stockholm' },
  { latitude: 59.184_677_9, longitude: 17.578_862_1, name: 'Södertälje' },
  { latitude: 58.586_727, longitude: 16.101_683_8, name: 'Norrköping' },
  { latitude: 57.700_67, longitude: 11.968_22, name: 'Göteborg' },
  { latitude: 59.893_915_2, longitude: 10.702_545_9, name: 'Oslo' },
  { latitude: 60.135_675_3, longitude: 12.979_163_6, name: 'Torsby' },
  { latitude: 60.731_894_1, longitude: 14.995_253, name: 'Leksand' },
];

const origin = locations[0];
const vias = locations.slice(1);
const destination = locations[0];

type LatitudeLongitudeElevation = [latitude: number, longitude: number, elevation: number];
interface RouteSection {
  polyline: string;
}
interface RouteResponse {
  routes: {
    sections?: RouteSection[];
  }[];
}

const days: RouteWeekDay[] = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

const getDayForSection = (sectionIndex: number): RouteWeekDay => days[sectionIndex % days.length];

const getVehicleRoute = async (): Promise<GetVehicleRouteResponseVM> => {
  const parameters = new URLSearchParams();

  parameters.set('transportMode', 'truck');
  parameters.set('departureTime', new Date().toISOString());
  parameters.set('apiKey', HERE_MAPS_API_KEY);
  parameters.set('origin', [origin.latitude, origin.longitude].join(','));

  for (const via of vias) {
    parameters.append('via', [via.latitude, via.longitude].join(','));
  }

  parameters.set('destination', [destination.latitude, destination.longitude].join(','));
  parameters.set('return', 'summary,polyline');

  const response = await fetch(`${ROUTER_API}/v8/routes?${parameters.toString()}`);
  const body = (await response.json()) as RouteResponse;

  const sections = body.routes[0]?.sections ?? [];

  const routePointsByDay: VehicleRoutePoint[][] = [];

  for (const [sectionIndex, section] of sections.entries()) {
    const day = getDayForSection(sectionIndex);

    const raw = flex.decode(section.polyline) as unknown as {
      polyline: LatitudeLongitudeElevation[];
    };

    const sectionPoints: VehicleRoutePoint[] = [];

    for (const [latitude, longitude] of raw.polyline) {
      sectionPoints.push({
        latitude,
        longitude,
        day,
      });
    }

    routePointsByDay.push(sectionPoints);
  }

  return { routePoints: routePointsByDay };
};

export default getVehicleRoute;
